import { CrudRouter, TreeCrudRouter } from "javaee-fre";
import { orgTree } from "./comm-func.js";
const RechargeLogs = () => import("../views/recharge-logs.vue");
const DialogList = () => import("../components/dialog-list.vue");
const routers = [
{
    path: 'home/admin/my/tenant/price/recharge', component: CrudRouter, meta: {
        listItemActions: [{
            label: '课次消费记录', icon: 'timeline', func(cfg) {
                this.$router.push(`/console/home/admin/my/tenant/price/recharge/log/${cfg.item.id}`, `课次消费记录 - ${cfg.item.name}`);
            }
        }]
    },
    children: [{ path: 'log/:_rid', component: RechargeLogs, meta: { name: '课次消费记录', url: '/home/admin/my/tenant/price/recharge/log' } }]
},
{
    path: 'home/admin/my/tenant/price/limit', component: TreeCrudRouter, meta: {
        acceptEmptyActive: true,
        tree: orgTree(true),
        crud(i) {
            return {
                genParams(i) {
                    return { _org: i ? i.id : null };
                },
                createable: i != null
            }
        }
    }
},
{
    path: 'home/admin/my/tenant/price/clazz', component: TreeCrudRouter, meta: {
        acceptEmptyActive: true,
        tree: orgTree(true),
        crud: {
            createable: false,
            genParams(i) {
                return { _org: i ? i.id : null };
            },
            onEditSelect(e) {
                let self = this;
                if (e.field != 'protoId') {
                    return;
                }
                self.$dialog.crud('选择批量生成模版', { url: '/home/admin/my/tenant/proto/clazz', selectStyle: 'single', editable: false, createable: false, deleteable: false }, [{
                    label: '确认', color: 'primary', func(sel) {
                        if (sel) {
                            let keys = Object.keys(sel);
                            if (keys.length > 0) {
                                let o = sel[keys[0]];
                                e.cb(o.name, o.id);
                            }
                        }
                    }
                }]);
            },
            selectStyle: 'multi',
            listActions: [{
                whereSel: true, label: '批量设置', func() {
                    let self = this, sels = Object.keys(self.selected());
                    if (sels.length == 0) {
                        return;
                    }
                    self.$dialog.crud('批量设置收费方案', {
                        width: 600,
                        forceEditFormStretch: true,
                        createable: true, url: '/home/admin/my/tenant/price/clazz',
                        initPanel: 'edit', params: { _ids: sels.join('_') }, onSaveSuccess() {
                            self.$dialog.close();
                            self.refresh(false, true);
                        }
                    });
                }
            }],
            listItemActions: [
                {
                    label: '查看培训方案', icon: 'calendar_today', func(cfg) {
                        this.$dialog.component(`培训方案 - ${cfg.item.name}`, "clazzrule-view", { targetId: this.$dictVal(cfg.item.ruleId), fullscreen: true});
                    }
                }, {
                    label: '查看阅读设置', icon: 'library_books', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/my/tenant/price/clazz/articles/${cfg.item.id}`).then(r => {
                            let as = r.data.message;
                            if (!as || as.length == 0) {
                                self.$status('没有阅读', 'success');
                                return;
                            }
                            let list = [];
                            for (let a of as) {
                                list.push(a.title);
                            }
                            self.$dialog.component(`查看阅读设置 - ${cfg.item.name}`, DialogList, { list: list });
                        });
                    }
                }
            ],
            listItemFilter(i, acts) {
                let s = this.$dictVal(i.priceStatus), rid = this.$dictVal(i.priceRuleId);
                if (rid === 0) {
                    i._rowClazz = 'red--text';
                } else if (s == 3) {
                    i._rowClazz = 'red--text';
                }

                if (!i.readJoinExam) {
                    this.delAction(acts, 'icon', 'library_books');
                }
                return acts;
            }
        }
    }
}];
export default {
    routers: routers
}